module.exports = __webpack_public_path__ + "static/image2-e50f68afdaeb82eeae34ed7e9c70b7a8.jpg";